import { render } from "./PlayerScoutReportForm.vue?vue&type=template&id=9ca0f1b4"
import script from "./PlayerScoutReportForm.vue?vue&type=script&lang=js"
export * from "./PlayerScoutReportForm.vue?vue&type=script&lang=js"

import "./PlayerScoutReportForm.vue?vue&type=style&index=0&id=9ca0f1b4&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__